import { render, staticRenderFns } from "./ALongOverduePoem.vue?vue&type=template&id=48ca11be&scoped=true&lang=pug&"
import script from "./ALongOverduePoem.vue?vue&type=script&lang=js&"
export * from "./ALongOverduePoem.vue?vue&type=script&lang=js&"
import style0 from "./ALongOverduePoem.vue?vue&type=style&index=0&id=48ca11be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ca11be",
  null
  
)

export default component.exports